import { AuthFeedbackPage } from '@shared/components/error-pages/auth-feedback-page/AuthFeedbackPage';
import * as React from 'react';

import type { AuthErrorScreenProps } from './AuthErrorScreen.types';

const AuthErrorScreen = React.memo(
  ({
    onRetry,
    onLogin,
  }: Readonly<AuthErrorScreenProps>): React.ReactElement => (
    <AuthFeedbackPage
      type="auth-error"
      primaryActionLabel="Try again"
      onPrimaryAction={onRetry}
      secondaryActionLabel={onLogin ? 'Log in again' : undefined}
      onSecondaryAction={onLogin}
    />
  )
);

AuthErrorScreen.displayName = 'AuthErrorScreen';

export { AuthErrorScreen };
